module.exports = __webpack_public_path__ + "img/logo_home.36fe8e48.png";